import React from 'react';
import getConfig from 'next/config';

import {Tenant} from '~/src/utilities/constants/tenant';
import {SiteArea} from '~/src/utilities/constants/navigation';

import LematinLogo from '~/src/components/svg/external/LematinLogo';

const {publicRuntimeConfig: config} = getConfig();

const MainLogo = ({siteArea}) => {
    const clipped = config.tenantId === Tenant.LEMATIN && siteArea === SiteArea.NEWS;

    if (config.tenantId === Tenant.LEMATIN) {
        return LematinLogo({clipped});
    }

    return (
        <svg viewBox="0 0 41 54">
            <image width="41" height="54" href={config.mainLogoPath} />
        </svg>
    );
};

export default MainLogo;
